import angular from "angular";

angular
    .module('api-sentinel')
    .factory('FeedbackService', FeedbackService);

FeedbackService.$inject = ['$rootScope'];

function FeedbackService($rootScope) {
    const service = {
        message: null,
        class: null,
        icon: null,
        addError,
        addErrorFromError,
        addSuccess,
        addNotice,
        clear,
        clearError
    };

    return service;

    function addError(message) {
        $rootScope.$applyAsync(() => {
            service.message = message;
            service.class = 'alert-danger';
            service.icon = 'fa-exclamation-triangle';
        });
    }

    function addErrorFromError(error) {
        const message =
            error.data?.message ||
            error.data?.error_description ||
            error.message ||
            (typeof error.data === 'string' ? error.data : typeof error === 'string' ? error : 'Unknown error');
        this.addError(message);
    }

    function addNotice(message) {
        $rootScope.$applyAsync(() => {
            service.message = message;
            service.class = 'alert-info';
            service.icon = 'fa-info-circle';
        });
    }

    function addSuccess(message) {
        $rootScope.$applyAsync(() => {
            service.message = message;
            service.class = 'alert-success';
            service.icon = 'fa-check-square';
        });
    }

    function clear() {
        $rootScope.$applyAsync(() => {
            service.message = null;
            service.class = null;
            service.icon = null;
        });
    }

    function clearError(message) {
        $rootScope.$applyAsync(() => {
            if (service.message === message) {
                service.message = null;
                service.class = null;
                service.icon = null;
            }
        });
    }
}
